module.exports = "pegasus/assets/image_library_block.png";